import { render } from "./CookiePolicy.vue?vue&type=template&id=6aedff08&scoped=true"
import script from "./CookiePolicy.vue?vue&type=script&lang=js"
export * from "./CookiePolicy.vue?vue&type=script&lang=js"

import "./CookiePolicy.vue?vue&type=style&index=0&id=6aedff08&scoped=true&lang=scss"
import "./CookiePolicy.vue?vue&type=style&index=1&id=6aedff08&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aedff08"]])

export default __exports__